/// <amd-module name="VSSUI/Utilities/HubViewState" />
import * as React from "react";
import { IObservableValue } from "VSS/Core/Observable";
import { IViewState, ViewState, ViewStateFilter, ViewStateOptions, ViewStateObservableValue } from "./ViewState";
import { IFilter, IFilterOptions, IFilterState } from "VSSUI/Utilities/Filter";
import { IViewOptions, IViewOptionsProps, IViewOptionsValues } from "./ViewOptions";

/**
 * The keys for common view options known by the Hub component
 */
/** @deprecated */
export namespace HubViewOptionKeys {
    /**
     * View option controlling whether or not the hub filter bar is being displayed.
     */
    /** @deprecated */
    export const showFilterBar = "showFilters";

    /**
     * View option controlling whether or not the page is in full-screen mode
     */
    /** @deprecated */
    export const fullScreen = "fullScreen";
}

/**
 * Names of observable events triggered by hub view state
 */
/** @deprecated */
export namespace HubViewStateEventNames {
    /**
     * Event fired when the pivot is being changed. Consumers can listen for this
     * event and modify other view state values. This event is not fired when
     * the selected pivot value is changed during the processing of another view-state's event.
     */
    /** @deprecated */
    export const pivotChanging = "pivotChanging";

    /**
     * Event fired when the applied filter is being changed. Consumers can listen for this
     * event and modify other view state values. This event is not fired when
     * the filter is changed during the processing of another view-state's event.
     */
    /** @deprecated */
    export const filterChanging = "filterChanging";

    /**
     * Event fired when a view option value is being changed. Consumers can listen for this
     * event and modify other view state values. This event is not fired when
     * a view option value is changed during the processing of another view-state's event.
     */
    /** @deprecated */
    export const viewOptionsChanging = "viewOptionsChanging";
}

/**
 * Store for the current view of a hub (selected pivot, filters, view options, etc.)
 */
/** @deprecated */
export interface IHubViewState extends IViewState<IViewOptionsValues | IFilterState | string> {
    /**
     * The key of the currently selected hub pivot
     */
    selectedPivot: IObservableValue<string>;

    /**
     * Filter applied to the hub
     */
    filter: IFilter;

    /**
     * View options used by the hub
     */
    viewOptions: IViewOptions;

    /**
     * Called by the Hub before the user switches pivots, return false to block the change.
     */
    canSwitchPivots(targetPivot: string): boolean;
}

/**
 * Initialization options for HubViewState
 */
/** @deprecated */
export interface IHubViewStateOptions {
    /**
     * Filter to use for the hub
     */
    filterOptions?: IFilterOptions;

    /**
     * View options used by the hub
     */
    viewOptions?: IViewOptionsProps;

    /**
     * The key of the default pivot. The selected pivot is set to this value initially.
     */
    defaultPivot?: string;
}

/**
 * Store for the current view of a hub (selected pivot, filters, view options, etc.)
 */
/** @deprecated */
export class HubViewState extends ViewState<IViewOptionsValues | IFilterState | string> implements IHubViewState {
    private _viewOptions: IViewOptions;
    private _filter: IFilter;
    private _selectedPivot: IObservableValue<string>;

    constructor(options: IHubViewStateOptions = {}) {
        super();

        this._viewOptions = new ViewStateOptions(this.notify.bind(this) as any, HubViewStateEventNames.viewOptionsChanging, options.viewOptions);
        this._filter = new ViewStateFilter(this.notify.bind(this) as any, HubViewStateEventNames.filterChanging, options.filterOptions);
        this._selectedPivot = new ViewStateObservableValue<string>(
            this.notify.bind(this) as any,
            HubViewStateEventNames.pivotChanging,
            options.defaultPivot
        );
    }

    public get selectedPivot(): IObservableValue<string> {
        return this._selectedPivot;
    }

    public get filter(): IFilter {
        return this._filter;
    }

    public get viewOptions(): IViewOptions {
        return this._viewOptions;
    }

    public canSwitchPivots(targetPivot: string): boolean {
        return true;
    }
}


/** @deprecated */
export const HubViewStateContext = React.createContext<{ hubViewState: IHubViewState }>({ hubViewState: null });
